export default "__VITE_ASSET__CVP8avna__"